module.exports = __webpack_public_path__ + "static/media/melodiekao.6da3206b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/melodiekao.jpg
// module id = 150
// module chunks = 0